$(document).ready(function() {
  $('#top_bar_ATC_button button').on('click', function(e) {
    e.preventDefault();
    var $this = $(this);
    var variant_ID = $this.attr('data-variant-ID');
    var selected_quantity = $('#top_bar_quantity_input').val();
    $this.addClass('adding_to_cart');
    CartJS.addItem(variant_ID, selected_quantity, {}, {
      "success": function(data, textStatus, jqXHR) {
        update_values_on_cart_header_button();
        $('#CartToggle').trigger('click');
      },
      "error": function(jqXHR, textStatus, errorThrown) {
        console.info('There was a problem adding to the cart!');
      }
    });
  });

  $('#top_bar_select').on('change', function(e) {
    e.preventDefault();
    var $this = $(this);
    var selected_variant_ID = $this.val();
    var selected_variant_price = $('option:selected',$(this)).attr('data-variant-price');
    $('#top_bar_price').html( selected_variant_price );
    $('#top_bar_ATC_button button').attr('data-variant-id', selected_variant_ID);
  });

  $('input#Quantity').on('change', function(e) {
    $('#top_bar_quantity_input').val( $(this).val() );
  });

  // quantity input on steroids
  $('.btn-number').click(function(e){
    e.preventDefault();

    fieldName = $(this).attr('data-field');
    type      = $(this).attr('data-type');
    var input = $("input[name='"+fieldName+"']");
    var currentVal = parseInt(input.val());
    if (!isNaN(currentVal)) {
      if(type == 'minus') {

        if(currentVal > input.attr('min')) {
          input.val(currentVal - 1).change();
        } 
        if(parseInt(input.val()) == input.attr('min')) {
          $(this).attr('disabled', true);
        }

      } else if(type == 'plus') {

        if(currentVal < input.attr('max')) {
          input.val(currentVal + 1).change();
        }
        if(parseInt(input.val()) == input.attr('max')) {
          $(this).attr('disabled', true);
        }

      }
    } else {
      input.val(0);
    }
  });
  $('.input-number').focusin(function(){
    $(this).data('oldValue', $(this).val());
  });
  $('.input-number').change(function() {

    minValue =  parseInt($(this).attr('min'));
    maxValue =  parseInt($(this).attr('max'));
    valueCurrent = parseInt($(this).val());

    name = $(this).attr('name');
    if(valueCurrent >= minValue) {
      $(".btn-number[data-type='minus'][data-field='"+name+"']").removeAttr('disabled')
    } else {
      $(this).val(1);
    }
    if(valueCurrent <= maxValue) {
      $(".btn-number[data-type='plus'][data-field='"+name+"']").removeAttr('disabled')
    } else {
      $(this).val($(this).data('oldValue'));
    }


  });
  $(".input-number").keydown(function (e) {
    // Allow: backspace, delete, tab, escape, enter and .
    if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
        // Allow: Ctrl+A
        (e.keyCode == 65 && e.ctrlKey === true) || 
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)) {
      // let it happen, don't do anything
      return;
    }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
      e.preventDefault();
    }
  });
});